import React from 'react';
import { ButtonsContainer, ButtonWithLoader, FormWrapper } from 'virtues-bootstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import Form from './components/Form';

const DeviceInformationFrom = ({
  alert,
  shockNa,
  onChangeShockCheckbox,
  handleSubmit,
  pristine,
  submitting,
  t,
}) => (
  <form onSubmit={handleSubmit}>
    <FormWrapper title={t('reports.deviceInformation')}>
      <Form alert={alert} shockNa={shockNa} onChangeShockCheckbox={onChangeShockCheckbox} />
      <ButtonsContainer>
        <ButtonWithLoader disabled={pristine} loading={submitting}>
          {t('detailedEPReport.saveChanges')}
        </ButtonWithLoader>
      </ButtonsContainer>
    </FormWrapper>
  </form>
);

DeviceInformationFrom.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  alert: PropTypes.bool,
  t: PropTypes.func.isRequired,
  shockNa: PropTypes.bool.isRequired,
  onChangeShockCheckbox: PropTypes.func.isRequired,
};

DeviceInformationFrom.defaultProps = {
  alert: false,
};

export default withTranslation()(DeviceInformationFrom);
